module.exports = __webpack_public_path__ + "img/warning.c7fbdba6.svg";